"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._MapContentTypeWithContentTypeExt = exports.EN_CONTENT_TYPE_EXT = exports.EN_CONTENTS_TYPE_DOMESTIC_PLACE = exports.EN_CONTENTS_TYPE_TITLE = exports.EN_CONTENTS_TYPE_STRING = exports.EN_CONTENTS_TYPE_CODE_FOR_POINT_API = exports.EN_CONTENTS_TYPE_CODE = exports.EN_CONTENTS_TYPE = void 0;
/**
 * 숙소형식 구분 값
 * 기존 하위호환을 위해 남겨두며, EN_CONTENTS_TYPE_CODE 사용 권장
 * 가능하다면 Replace All 로 중복되는 enum 을 삭제해도 된다.
 * @deprecated EN_CONTENTS_TYPE_CODE 를 씁시다.
 */
var EN_CONTENTS_TYPE;
(function (EN_CONTENTS_TYPE) {
    /** Content API v2에서는 -1을 사용하지 않음, 또는 전체로 사용한다 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["NEGATIVE_NOT_USE"] = -1] = "NEGATIVE_NOT_USE";
    /** 전체 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["ALL"] = 0] = "ALL";
    /** 모텔 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["Motel"] = 1] = "Motel";
    /** 호텔 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["Hotel"] = 2] = "Hotel";
    /** 펜션 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["Pension"] = 3] = "Pension";
    /** 게스트하우스 */
    EN_CONTENTS_TYPE[EN_CONTENTS_TYPE["GuestHouse"] = 4] = "GuestHouse";
})(EN_CONTENTS_TYPE = exports.EN_CONTENTS_TYPE || (exports.EN_CONTENTS_TYPE = {}));
var EN_CONTENTS_TYPE_CODE;
(function (EN_CONTENTS_TYPE_CODE) {
    /** Content API v2에서는 -1을 사용하지 않음, 또는 전체로 사용한다 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["NEGATIVE_NOT_USE"] = -1] = "NEGATIVE_NOT_USE";
    /** 전체 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["ALL"] = 0] = "ALL";
    /** 모텔 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["MOTEL"] = 1] = "MOTEL";
    /** 호텔 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["HOTEL"] = 2] = "HOTEL";
    /** 펜션 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["PENSION"] = 3] = "PENSION";
    /** 게스트하우스 */
    EN_CONTENTS_TYPE_CODE[EN_CONTENTS_TYPE_CODE["GUESTHOUSE"] = 4] = "GUESTHOUSE";
})(EN_CONTENTS_TYPE_CODE = exports.EN_CONTENTS_TYPE_CODE || (exports.EN_CONTENTS_TYPE_CODE = {}));
// 아 이걸 또 따로 만들어야되나... GUESTHOUSE 가 다름..
var EN_CONTENTS_TYPE_CODE_FOR_POINT_API;
(function (EN_CONTENTS_TYPE_CODE_FOR_POINT_API) {
    /** 모텔 */
    EN_CONTENTS_TYPE_CODE_FOR_POINT_API[EN_CONTENTS_TYPE_CODE_FOR_POINT_API["MOTEL"] = 1] = "MOTEL";
    /** 호텔 */
    EN_CONTENTS_TYPE_CODE_FOR_POINT_API[EN_CONTENTS_TYPE_CODE_FOR_POINT_API["HOTEL"] = 2] = "HOTEL";
    /** 펜션 */
    EN_CONTENTS_TYPE_CODE_FOR_POINT_API[EN_CONTENTS_TYPE_CODE_FOR_POINT_API["PENSION"] = 3] = "PENSION";
    /** 게스트하우스 */
    EN_CONTENTS_TYPE_CODE_FOR_POINT_API[EN_CONTENTS_TYPE_CODE_FOR_POINT_API["GUEST_HOUSE"] = 4] = "GUEST_HOUSE";
})(EN_CONTENTS_TYPE_CODE_FOR_POINT_API = exports.EN_CONTENTS_TYPE_CODE_FOR_POINT_API || (exports.EN_CONTENTS_TYPE_CODE_FOR_POINT_API = {}));
var EN_CONTENTS_TYPE_STRING;
(function (EN_CONTENTS_TYPE_STRING) {
    EN_CONTENTS_TYPE_STRING["NEGATIVE_NOT_USE"] = "NEGATIVE_NOT_USE";
    /** 전체 (type 0) */
    EN_CONTENTS_TYPE_STRING["ALL"] = "ALL";
    /** 모텔 (type 1) */
    EN_CONTENTS_TYPE_STRING["MOTEL"] = "MOTEL";
    /** 호텔 (type 2) */
    EN_CONTENTS_TYPE_STRING["HOTEL"] = "HOTEL";
    /** 펜션 (type 3) */
    EN_CONTENTS_TYPE_STRING["PENSION"] = "PENSION";
    /** 게스트하우스 (type 4) */
    EN_CONTENTS_TYPE_STRING["GUESTHOUSE"] = "GUESTHOUSE";
})(EN_CONTENTS_TYPE_STRING = exports.EN_CONTENTS_TYPE_STRING || (exports.EN_CONTENTS_TYPE_STRING = {}));
var EN_CONTENTS_TYPE_TITLE;
(function (EN_CONTENTS_TYPE_TITLE) {
    /** 모텔 (type 1) */
    EN_CONTENTS_TYPE_TITLE["MOTEL"] = "\uBAA8\uD154";
    /** 호텔 (type 2) */
    EN_CONTENTS_TYPE_TITLE["HOTEL"] = "\uD638\uD154";
    /** 펜션 (type 3) */
    EN_CONTENTS_TYPE_TITLE["PENSION"] = "\uD39C\uC158";
    /** 게스트하우스 (type 4) */
    EN_CONTENTS_TYPE_TITLE["GUESTHOUSE"] = "\uAC8C\uC2A4\uD2B8\uD558\uC6B0\uC2A4";
})(EN_CONTENTS_TYPE_TITLE = exports.EN_CONTENTS_TYPE_TITLE || (exports.EN_CONTENTS_TYPE_TITLE = {}));
/** 국내 숙소에서 사용하는 모호펜게만 정리한 것 */
var EN_CONTENTS_TYPE_DOMESTIC_PLACE;
(function (EN_CONTENTS_TYPE_DOMESTIC_PLACE) {
    /** 모텔 */
    EN_CONTENTS_TYPE_DOMESTIC_PLACE["MOTEL"] = "MOTEL";
    /** 호텔 */
    EN_CONTENTS_TYPE_DOMESTIC_PLACE["HOTEL"] = "HOTEL";
    /** 펜션 */
    EN_CONTENTS_TYPE_DOMESTIC_PLACE["PENSION"] = "PENSION";
    /** 게스트하우스 */
    EN_CONTENTS_TYPE_DOMESTIC_PLACE["GUESTHOUSE"] = "GUESTHOUSE";
})(EN_CONTENTS_TYPE_DOMESTIC_PLACE = exports.EN_CONTENTS_TYPE_DOMESTIC_PLACE || (exports.EN_CONTENTS_TYPE_DOMESTIC_PLACE = {}));
/**
 * Joy 내부에서만 사용하는 숙소 유형
 */
var EN_CONTENT_TYPE_EXT;
(function (EN_CONTENT_TYPE_EXT) {
    /** 매핑 실패 */
    EN_CONTENT_TYPE_EXT["UNKNOWN"] = "UNKNOWN";
    /** 전체 유형 = '유형', 글로벌 숙소만 */
    EN_CONTENT_TYPE_EXT["ALL_ONLY_GLOBAL"] = "ALL_ONLY_GLOBAL";
    /** 전체 유형 = '유형', 국내 숙소만 */
    EN_CONTENT_TYPE_EXT["ALL_ONLY_LOCAL"] = "ALL_ONLY_LOCAL";
    /** 전체 유형 = '유형', 국내 + 글로벌 */
    EN_CONTENT_TYPE_EXT["ALL_WITH_GLOBAL"] = "ALL_WITH_GLOBAL";
    /** 모텔 */
    EN_CONTENT_TYPE_EXT["MOTEL"] = "MOTEL";
    /** 호텔 */
    EN_CONTENT_TYPE_EXT["HOTEL"] = "HOTEL";
    /** 펜션 */
    EN_CONTENT_TYPE_EXT["PENSION"] = "PENSION";
    /** 게스트하우스 */
    EN_CONTENT_TYPE_EXT["GUESTHOUSE"] = "GUESTHOUSE";
    /** 글로벌-라쿠텐 */
    EN_CONTENT_TYPE_EXT["GLOBAL_RLS"] = "GLOBAL_RLS";
    /** 글로벌-EAN */
    EN_CONTENT_TYPE_EXT["GLOBAL_EAN"] = "GLOBAL_EAN";
})(EN_CONTENT_TYPE_EXT = exports.EN_CONTENT_TYPE_EXT || (exports.EN_CONTENT_TYPE_EXT = {}));
exports._MapContentTypeWithContentTypeExt = {
    '-1': EN_CONTENT_TYPE_EXT.UNKNOWN,
    0: EN_CONTENT_TYPE_EXT.ALL_ONLY_LOCAL,
    1: EN_CONTENT_TYPE_EXT.MOTEL,
    2: EN_CONTENT_TYPE_EXT.HOTEL,
    3: EN_CONTENT_TYPE_EXT.PENSION,
    4: EN_CONTENT_TYPE_EXT.GUESTHOUSE,
};
//# sourceMappingURL=data:application/json;base64,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